<script lang='ts'>
  import { navigate } from 'svelte-routing'
  import Surveys from './surveys.svelte';
</script>

<Surveys on:complete={() => {
  navigate('/')
}}></Surveys>

